import { Tab } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { SettingsBuildingsTable } from '../../../components/Buildings/Tables/SettingsBuildingsTable';
import { Page } from '../../../components/Page/Page';
import { RoomsTable } from '../../../components/Rooms/Tables/RoomsTable';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SetupRoomsAndBuildings = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <Tab
        variant={'large'}
        tabs={[
          {
            title: t('rooms.title', { count: 2 }),
            value: 'rooms',
            content: <RoomsTable />,
          },
          {
            title: t('buildings.title', { count: 2 }),
            value: 'buildings',
            content: <SettingsBuildingsTable />,
          },
        ]}
      />
    </Page>
  );
};
